// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","348":"5c0b189e","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"58821864980ae2f0b7bd","245":"72a7cda541a6be6308bc","348":"960d70b4ad567711f9e6","453":"a9a24959e849f35733bd","522":"1d3da8565fa44bd23641"}[chunkId] + ".js";
};